import noLicenseBackdrop from "@/assets/no-license-backdrop.png";
import AccountAvatar from "@/components/AccountAvatar";
import { AccountIdentity } from "@/mappers/user/accountIdentityMapper";
import { Lock } from "lucide-react";
import { ReactNode } from "react";

type NoLicenseViewProps = {
    account: AccountIdentity;
    title: string;
    description: string;
    cta?: ReactNode;
    accountAction: ReactNode;
};

const NoLicenseView = ({
    account,
    title,
    description,
    cta,
    accountAction,
}: NoLicenseViewProps) => (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto p-4">
        <img
            alt=""
            className="pointer-events-none absolute inset-0 h-full w-full scale-105 object-cover blur-xl"
            src={noLicenseBackdrop}
            aria-hidden
        />
        <div className="absolute inset-0 bg-neutral-900/60" aria-hidden />

        <div
            className="relative w-full max-w-md flex-col rounded-3xl bg-white p-8 shadow-2xl"
            role="dialog"
            aria-modal
        >
            <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-purple-100">
                <Lock className="h-6 w-6 text-purple-700" />
            </div>

            <h1 className="mb-3 font-display text-3xl font-bold leading-tight text-text-mainTitle">
                {title}
            </h1>

            <p className="mb-8 text-base leading-relaxed text-text-body">
                {description}
            </p>

            {cta && <div className="flex flex-col mb-10">{cta}</div>}

            <div className="mt-auto flex items-center justify-between gap-4 border-t border-border-primary pt-5">
                <div className="flex min-w-0 items-center gap-3">
                    <AccountAvatar
                        account={account}
                        className="h-9 w-9 shrink-0"
                    />
                    <div className="flex min-w-0 flex-col">
                        <span className="truncate text-sm font-semibold text-text-mainTitle">
                            {account.displayName}
                        </span>
                        <span className="truncate text-xs text-text-caption">
                            {account.email}
                        </span>
                    </div>
                </div>
                {accountAction}
            </div>
        </div>
    </div>
);

export default NoLicenseView;
